/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, {useState, useEffect, useCallback, useContext} from 'react'
import { distributorService } from '../../../service/distributor.service';
import { PriceHandler } from '../../../redux/helper/CamelCase';
import Skeleton from './Skelton';
import EmptyOrderPage from '../../MyOrders/EmptyOrderPage';
import HeaderContext from '../../../Components/Context/HeaderContext';


const OutstandingReport = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [oustandingReportList, setOustandingReportList] = useState([]);
    const [emptyData, setEmptyData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;

    const handleOutstandingReport = useCallback((() => {
        distributorService.MISViewCustomerWiseOutstandingReport(DISTRIBUTOR.ACCOUNT_NUMBER).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                    setOustandingReportList({});
                } else {
                    setEmptyData(false);
                    setLoading(false);
                    setOustandingReportList(response.data.data[0]);
                }
                setLoading(false);
                
            } else {
                setLoading(false);
            }
        });
    }), [DISTRIBUTOR.ACCOUNT_NUMBER]);


    const handleExport = useCallback((() => {
        distributorService.MISViewCustomerWiseOutstandingReport(DISTRIBUTOR.ACCOUNT_NUMBER, exportSelected ).then((response) => {
            if (response.data.success_status) {
                SetSuccessMessage(response.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(response.data.url, '_blank');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleOutstandingReport();
    }, [handleOutstandingReport]);


    return (
        <div className="md:px-[46px] px-4 sm:pt-[30px] pt-3.5">
            {(loading && !emptyData) ? <Skeleton /> : (
                <div>
                    <div className="flex items-center justify-between flex-wrap pb-[10px]">
                        <h5 className="sm:text-xs10 text-lg font-semibold text-[#090406] lg:mb-0 mb-3">Outstanding Report</h5> 
                        <div className="lg:mb-0 mb-3">
                            <div className="flex sm:mx-2 mx-0 items-center flex-wrap w-full">
                                <div className="pl-2 dropdown relative">
                                    <button 
                                        type="button" 
                                        id="exportDropdown" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false"
                                        disabled={emptyData}
                                        className="dropdown-toggle text-xs2 font-semibold text-[#555259] sm:py-2.5 py-1.5 sm:px-4 px-2 border border-[#555259] rounded-lg"
                                        onClick={()=>setexportClick(!exportClick)} 
                                    >
                                        Generate Report
                                    </button>
                                    <ul className={`dropdown-menu sm:min-w-[125px] min-w-[120px] ${exportClick ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] sm:p-3.5 p-1.5`} aria-labelledby="exportDropdown">
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"  
                                                href="#"
                                                onClick={() => {
                                                    setexportSelected('csv')}}
                                            >CSV</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected(`pdf-converter`)}

                                            >PDF</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected('excel')}
                                            >Excel</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overflow-auto sidebar  pb-7 relative z-[6]" style={{height: 'calc(100vh - 193px)'}}>
                        <table className="w-full table-auto relative">
                            <thead className='sticky top-0 left-0 z-[1]'>
                                <tr className="bg-[#555259] h-10">
                                    <th className="py-2.5 sm:px-7 px-3 rounded-bl-lg rounded-tl-lg border-r border-[#DFEAF7] min-w-[136px] text-start" scope="col">
                                        <span className="text-xs5 font-bold text-[#FFFFFF]">
                                            Description
                                        </span>
                                    </th>
                                    <th scope="col" className="py-5.5 sm:px-7 px-3 min-w-[150px] rounded-br-lg rounded-tr-lg text-end">
                                        <span className="text-xs5 font-bold text-[#FFFFFF]">
                                            Amount
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        Total Outstanding                   
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-end">
                                        {PriceHandler(oustandingReportList?.TOTAL_OUTSTANDING || 0)}                      
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        Current Total                   
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-end">
                                        {PriceHandler(oustandingReportList?.CURRENT_TOTAL || 0)}                          
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        Total Due                  
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3  text-end">
                                        {PriceHandler(oustandingReportList?.AMOUNT_DUE_REMAIN || 0)}                        
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        30 Days Total                   
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3  text-end">
                                        {PriceHandler(oustandingReportList['30_DAYS'] !== undefined ?oustandingReportList['30_DAYS']: 0)}                       
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        60 Days Total                    
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3  text-end">
                                        {PriceHandler(oustandingReportList['60_DAYS'] !== undefined? oustandingReportList['60_DAYS'] : 0)}                         
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        90 Days Total                  
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3  text-end">
                                        {PriceHandler(oustandingReportList['90_DAYS'] !== undefined? oustandingReportList['90_DAYS']: 0)}                       
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        180 Days Total                     
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3  text-end">
                                        {PriceHandler(oustandingReportList['180_DAYS'] !== undefined? oustandingReportList['180_DAYS'] : 0)}                       
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        360 Days Total                      
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3  text-end">
                                        {PriceHandler(oustandingReportList['360_DAYS'] !== undefined ? oustandingReportList['360_DAYS'] : 0)}                         
                                    </td>
                                </tr>
                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 border-r border-[#DFEAF7]">
                                        361 Days Total                    
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3  text-end">
                                        {PriceHandler(oustandingReportList['360+DAYS'] !== undefined? oustandingReportList['360+DAYS'] : 0)}                         
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* {emptyData && <EmptyOrderPage search="yes" text="no Outstanding Report " all={'found'} />} */}
                </div> 
            )}
            
        </div>
    )
}

export default OutstandingReport
